// extracted by mini-css-extract-plugin
module.exports = {"SkipToMain":"SkipToMain_SkipToMain__evKtx"};